<template>
    <div
      class="slide-card relative overflow-hidden rounded-lg text-white mb-[30px]"
      :style="{ backgroundImage: `url(${randomBanner})`, backgroundSize: 'cover', backgroundPosition: 'center' }"
    >
      <div class="absolute inset-0 bg-black/50"></div>
      <!-- Header: Sport & League + Date -->
      <div class="relative top-2 left-2 right-2 z-10 text-white text-sm">
        <div class="flex items-center space-x-2">
            <div class="league-icn">
                <img src="/sport/1.svg" style="width: 23px;height: 23px;"/>
            </div>
          <span class="font-bold">{{regionTranslation(event)}} / <RouterLink :to="`ps/${event.si}/l/${event.ri}/${event.ci}`"> {{ event.cn }} </RouterLink></span>
        </div>
        <!-- Date & Time -->
        <div class="mt-2 text-xs flex items-center font-bold justify-center"v-if="event?.t" >{{ formattedDate }} , {{ formattedTime }}</div>
      </div>
      <!-- Teams Row -->
      <div class="relative z-10 flex justify-center h-32" v-if="event.o == 'false'">
        <div class="flex items-center space-x-4 justify-between px-10 w-full">
      
          <!-- Home Team -->
          <RouterLink :to="`/pre/${event.i}`" class="flex-1 flex justify-center">
            <div class="flex flex-col items-center justify-start min-h-[80px]">
              <div class="h-[40px] flex items-start justify-center">
                 <div v-if="!homeKitError">
                    <img
                      v-if="event?.hi"
                      :src="`${assetsUrl}/teams/${event.hi}.png`"
                      class="w-[40px] h-[40px] object-contain"
                      @error="homeKitError = true"
                    />
                 </div>
                <div v-else class="w-[40px] h-[40px]">
                  <HShirt />
                </div>
              </div>
              <span class="text-xs font-bold text-center mt-1">{{ event.h }}</span>
            </div>
          </RouterLink>
          <!-- VS -->
          <div class="text-center text-lg font-bold px-2">VS</div>
          <!-- Away Team -->
          <RouterLink :to="`/pre/${event.i}`" class="flex-1 flex justify-center">
            <div class="flex flex-col items-center justify-start min-h-[80px]">
              <div class="h-[40px] flex items-start justify-center">
                  <div v-if="!awayKitError">
                    <img
                      v-if="event?.ai"
                      :src="`${assetsUrl}/teams/${event.ai}.png`"
                      class="w-[40px] h-[40px] object-contain"
                      @error="awayKitError = true"
                    />
                  </div>
                <div v-else class="w-[40px] h-[40px]">
                  <AShirt />
                </div>
              </div>
              <span class="text-xs font-bold text-center mt-1">{{ event.a }}</span>
            </div>
          </RouterLink>
      </div>
    </div>
    <!-- outright events -->
    <div class="relative z-10 flex justify-center h-32" v-if="event.o == 'true'">
      <RouterLink :to="`/pre/${event.i}`" class="flex-1 flex justify-center">
        <div class="flex flex-col items-center justify-center min-h-[80px]">
  
          <span class="text-xs font-bold text-center mt-1">{{ $t('events.outrightf') }}</span>
        </div>
      </RouterLink>
    </div>
    <div 
      class="absolute bottom-2 left-2 right-2 grid grid-cols-3 gap-2" 
      v-if="selections.length"
    >
      <Odd
        :odd="selections.find(s => s.n === '1')"
        :withName="true"
        odd-classes="px-2 py-2 text-sm font-semibold rounded"
        :fav-layout="true"
        :event="event"
        :mi="20890"
      />
      <Odd
        :odd="selections.find(s => s.n === 'X')"
        :withName="true"
        odd-classes="px-2 py-2 text-sm font-semibold rounded"
        :fav-layout="true"
        :event="event"
        :mi="20890"
      />
      <Odd
        :odd="selections.find(s => s.n === '2')"
        :withName="true"
        odd-classes="px-2 py-2 text-sm font-semibold rounded"
        :fav-layout="true"
        :event="event"
        :mi="20890"
      />
    </div>
  </div>
</template>
<script setup>
import { timestampToDayMonth, timestampToTime, safeTranslate } from '@/helpers';
import { useFixturesStore } from '@/stores/fixtures';
import { ref, onMounted } from 'vue';
import { useI18n } from 'vue-i18n'
import AShirt from '@/components/AShirt.vue';
import HShirt from '@/components/HShirt.vue';
import Odd from '@/components/Odd.vue';
import banners from '@/banners';

const assetsUrl = import.meta.env.VITE_ASSETS_URL
const props = defineProps({
  event: { type: Object, required: true }
});

const { t, te } = useI18n()
const fixtures = useFixturesStore()
const { event } = props;
let formattedDate = '';
let formattedTime = '';
const homeKitError = ref(false)
const awayKitError = ref(false)
const selections = ref([])

const randomBanner = ref(
  banners[Math.floor(Math.random() * banners.length)]
)

if (event.t) {
  const [dayName, dayOfMonth, monthName] = timestampToDayMonth(event.t);
  formattedDate = `${dayName} ${dayOfMonth} ${monthName}`;
  formattedTime = timestampToTime(event.t);
}

onMounted(async () => {
  const res = await fixtures.fetchSelections([Number(event.i)], "pre")
  if (res.length && res[0].m?.length) {
    selections.value = res[0].m[0].o 
  }
})
const regionTranslation = (event) => { 
  return safeTranslate('regions', event.ri, t, te , event.rn)
}
</script>
  
  <style scoped>
  .slide-card {
    width: 100%;
    height: 100%;
    max-height: 100%;  
    min-height: 220px;
    /* aspect-ratio: 16 / 9; */
    background-color: var(--color-white7);
    position: relative;
  }
  
  .team-placeholder {
    width: 2rem;
    height: 2rem;
    mask-image: url('/white-kit.svg');
    mask-size: contain;
    mask-repeat: no-repeat;
    mask-position: center;
    background-color: #fff;
    }
  .team-logo {
    width: 2rem;
    height: 2rem;
  }
  
  </style>
  